import Editor from '@tinymce/tinymce-vue'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('TinyEditor', Editor)
})
